import { render, staticRenderFns } from "./PrinterEditor.vue?vue&type=template&id=47e1f4c3&scoped=true"
import script from "./PrinterEditor.vue?vue&type=script&lang=js"
export * from "./PrinterEditor.vue?vue&type=script&lang=js"
import style0 from "./PrinterEditor.vue?vue&type=style&index=0&id=47e1f4c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e1f4c3",
  null
  
)

export default component.exports